import { ref } from "vue";

export const showLoginModal = ref<boolean>(false);

export const showProModal = ref<boolean>(false);

export const showSignupModal = ref<boolean>(false);
